<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Light Trap Enrollment
      </h2>
    </b-container>

    <hr>

    <b-container fluid class="tw-mb-5">
      <b-row class="tw-bg-gray-100 tw-border tw-border-blue-200">
        <b-col cols="9" class="tw-overflow-x-scroll" ref="lightTrapEnrollmentProgressChart">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
        </b-col>
        <b-col cols="3">
          <b-container>
            <b-row style="position: relative; top: 30px;">
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Core
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Total Collected
                    </p>
                    <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">
                      {{ totalCore }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col>
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Buffer
                    </h6>
                    <p class="text-secondary tw-text-xs text-center">
                      Total Collected
                    </p>
                    <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">
                      {{ totalBuffer }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>


      <b-card header-tag="nav" style="width: 100%; margin: 0;">
      <b-card-text>
        <b-row>
          <b-col class="text-right"><h2 style="position: relative; top: -3px;">Cluster:</h2></b-col>
          <b-col class="text-left"><b-select :options="clusters" v-model="selected_cluster" @change="get_lighttraps" style="width: 100px;"></b-select></b-col>
        </b-row>
        <span v-if="STUDY == 'kenya'">
          <b-row>
            <b-col class="text-right"><h2 style="position: relative; top: -3px;">Core: All, Buffer: Segment:</h2></b-col>
            <b-col class="text-left"><b-select :options="segment_drop_down_options" v-model="selected_segment" @change="get_lighttraps" style="width: 100px;"></b-select></b-col>
          </b-row>
          <b-row>
            <b-col class="mt-2" v-if="last_month_randomized_segment > 0">
              <center><h5 style="position: relative; top: -3px;">Buffer Segment {{last_month_randomized_segment}} was randomized for cluster {{ selected_cluster }} last month.</h5></center>
            </b-col>
          </b-row>
        </span>
        <hr />
        <b-row class="justify-content-md-center">
            <b-col col lg="2">
              <b-form-select v-model="month_selected" :options="months" @change="update_schedules()"></b-form-select>
            </b-col>
            <b-col col lg="1">
              <b-form-input v-model="year_selected" placeholder="YYYY"></b-form-input>
            </b-col>
        </b-row>
        <br />
        <b-row class="justify-content-md-center">
            <b-col col md="auto">
              <span v-if="randomize_enabled">
              <b-button variant="success" v-if="randomizing == false" @click="schedule_lighttraps">Randomize Light Trap Compounds <small>(Cluster {{ selected_cluster }})</small></b-button>
              <b-button variant="success" disabled v-else ><i class="fa fa-spin fa-spinner"></i> Randomizing Light Trap Compounds...</b-button>
              </span>
              <span v-else>
              <b-button variant="success" disabled title="There are still Light Trap schedules for the previous month.  Purge those before randomizing this month.">Randomize Light Trap Compounds <small>(Cluster {{ selected_cluster }})</small></b-button>
              </span>
            </b-col>
             <b-col cols="12" md="auto">
               <span v-if="randomize_enabled">
              <b-button variant="warning" v-if="committing == false" @click="commit_light_trap_schedule">Push Randomization to CommCare <small>(Cluster {{ selected_cluster }})</small></b-button>
              <b-button variant="warning" v-else disabled><i class="fa fa-spin fa-spinner"></i> Pushing Randomization...</b-button>
               </span>
               <span v-else>

              <b-button variant="warning" disabled title="There are still Light Trap schedules for the previous month.  Purge those before randomizing this month.">Push Randomization to CommCare <small>(Cluster {{ selected_cluster }})</small></b-button>
               </span>
            </b-col>
             <b-col col md="auto">
              <b-button variant="primary" v-if="purging == false" @click="purge_lighttraps">Purge Compounds of LTs <small>(Cluster {{ selected_cluster }})</small></b-button>
              <b-button variant="primary" v-else disabled><i class="fa fa-spin fa-spinner"></i> Purging...</b-button>
            </b-col>
        </b-row>
        <br />
        <b-row class="justify-content-md-center">

          <small>Changes to CommCare data are pushed at the top and bottom of every hour.</small>
        </b-row>
      </b-card-text>
      </b-card>

    <b-container fluid>
      <b-row style="padding: 20px;">
      <b-col>
        <h5 class="text-center">CORE</h5>
        <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="current_month_name" active>
            <b-card-text >
              <div style="padding-bottom: 50px;">
                 <b-alert v-if="core_loading" show>
                   Fetching data...
                  <i class="fas fa-spin fa-spinner"></i>
                </b-alert>
                <b-table v-else striped hover :items="core" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
                    <template v-slot:cell(enrollment_status)="data">
                      <i class="fa fa-clock" style="color: #6c757d;" v-if="data.item.enrollment_status == 'pending'" title="Visitation Pending"></i>
                      <i class="fa fa-check text-success" v-if="data.item.enrollment_status == 'collected'" title="Visit Completed"></i>
                      <i class="fa fa-user-times text-danger" v-if="data.item.enrollment_status == 'omitted'" title="Removed due to lack of subjects"></i>
                      <i class="fa fa-lightbulb text-warning" v-if="data.item.enrollment_status == 'light trap placed'" title="Light Trap Placed"></i>

                    </template>
                  </b-table>
                  <b-button class="float-right" variant="success" @click="get_month_schedules(this_core_page + 1, 'core')">More</b-button>
              </div>
            </b-card-text>
          </b-tab>
           <b-tab :title="next_month_name">
            <b-card-text>
        <div style="padding-bottom: 50px;">
              <b-table striped hover :items="core_next_month" :fields="next_fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
              </b-table>
              <b-button class="float-right" variant="success" @click="get_next_month_core(next_core_page + 1)">More</b-button>
        </div>
            </b-card-text>
           </b-tab>
        </b-tabs>
        </b-card>
      </b-col>

      <b-col>
        <h5 class="text-center">BUFFER</h5>
        <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="current_month_name" active>
            <b-card-text >
        <div style="padding-bottom: 50px;">
          <b-alert v-if="buffer_loading" show>
                   Fetching data...
                  <i class="fas fa-spin fa-spinner"></i>
                </b-alert>
            <b-table v-else striped hover :items="buffer" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
            <template v-slot:cell(enrollment_status)="data">
              <i class="fa fa-clock" style="color: #6c757d;" v-if="data.item.enrollment_status == 'pending'" title="Visitation Pending"></i>
              <i class="fa fa-check text-success" v-if="data.item.enrollment_status == 'collected'" title="Visit Completed"></i>
              <i class="fa fa-user-times text-danger" v-if="data.item.enrollment_status == 'omitted'" title="Removed due to lack of subjects"></i>
                <i class="fa fa-lightbulb text-warning" v-if="data.item.enrollment_status == 'light trap placed'" title="Light Trap Placed"></i>
            </template>
          </b-table>

          <b-button class="float-right" variant="success" @click="get_month_schedules(this_buffer_page + 1, 'buffer')">More</b-button>
        </div>
        </b-card-text>
          </b-tab>
           <b-tab :title="next_month_name">
            <b-card-text>
        <div style="padding-bottom: 50px;">
              <b-table striped hover :items="buffer_next_month" :fields="next_fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
              </b-table>
              <b-button class="float-right" variant="success" @click="get_next_month_buffer(next_buffer_page + 1)">More</b-button>
        </div>
            </b-card-text>
           </b-tab>
        </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-row style="padding: 20px; position: relative; top: -50px;">
      <b-col>
        <div>
          <b-card header-tag="nav">
            <b-card-text class="text-center">
              <h4 class="tw-font-bolder tw-mb-0 text-center">Core Enrollment Status</h4>
              <!-- <p class="text-secondary tw-text-xs text-center">Subheader for single number, if needed</p>
              <h1
                class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
              >{{raw}}</h1> -->

              <b-container>
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_removed }}
                    </h1>
                    <span>Omitted</span>
                  </b-col>
                  <b-col cols="auto" class="text-center" v-b-modal.enrolled_core_modal>
                    <h1 class="tw-text-6xl tw-font-bolder">
                      {{ core_enrolled.length }}
                    </h1>
                    <span class="tw-text-2xl">Enrolled</span>
                  </b-col>
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_pending }}
                    </h1>
                    <span>Remaining</span>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-text>
          </b-card>
         </div>
      </b-col>
      <b-col>
        <div>
          <b-card header-tag="nav">
            <b-card-text class="text-center">
              <h4 class="tw-font-bolder tw-mb-0 text-center">Buffer Enrollment Status</h4>
              <!-- <p class="text-secondary tw-text-xs text-center">Subheader for single number, if needed</p>
              <h1
                class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
              >{{raw}}</h1> -->

              <b-container>
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ buffer_removed }}
                    </h1>
                    <span>Omitted</span>
                  </b-col>
                  <b-col cols="auto" class="text-center" v-b-modal.enrolled_buffer_modal>
                    <h1 class="tw-text-6xl tw-font-bolder">
                      {{ buffer_enrolled.length }}
                    </h1>
                    <span class="tw-text-2xl">Enrolled</span>
                  </b-col>
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ buffer_pending }}
                    </h1>
                    <span>Remaining</span>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-text>
          </b-card>
         </div>
      </b-col>
    </b-row>
    </b-container>
    

    <b-modal id="enrolled_core_modal" title="Enrolled Compounds in CORE" ok-only>
      <span class="font-italic" v-if="core_enrolled.length == 0">No compounds have been enrolled yet.</span>
      <b-table striped hover borderless v-if="core_enrolled.length > 0" :items="core_enrolled" :fields="modal_fields">
             
      </b-table>
    </b-modal>

    <b-modal id="enrolled_buffer_modal" title="Enrolled Compounds in BUFFER" ok-only>
      <span class="font-italic" v-if="buffer_enrolled.length == 0">No compounds have been enrolled yet.</span>
      <b-table striped hover borderless v-if="buffer_enrolled.length > 0" :items="buffer_enrolled" :fields="modal_fields">
             
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as moment from 'moment';

import * as _ from "lodash";

import BarChart from "@/components/charts/BarChart.vue";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    BarChart
  },
  data: function() {
    return {
     randomize_enabled: false,
     current_month_name: moment().startOf("month").format('MMMM').toUpperCase(),
     next_month_name: moment().add(1, "month").startOf("month").format('MMMM').toUpperCase(),
     clusters: [],
     cluster_ids: [],
     light_traps: [],
     light_traps_next_month: [],
     selected_cluster: null,
     selected_segment: null,
     last_month_randomized_segment: null,
     segment_drop_down_options: [],
     core: [],
     core_next_month: [],
     core_removed: 0,
     core_enrolled: [],
     core_pending: 0,
     core_loading: false,
     buffer_loading: false,
     buffer_removed: 0,
     buffer_enrolled: [],
     buffer_pending: 0,
     buffer: [],
     buffer_next_month: [],
     next_month_scheduled: true,
     loaded: false,
     this_core_page: 1,
     this_buffer_page: 1,
     next_core_page: 1,
     next_buffer_page: 1,
     months: [
       { value: 1, text: 'January'},
       { value: 2, text: 'February'},
       { value: 3, text: 'March'},
       { value: 4, text: 'April'},
       { value: 5, text: 'May'},
       { value: 6, text: 'June'},
       { value: 7, text: 'July'},
       { value: 8, text: 'August'},
       { value: 9, text: 'September'},
       { value: 10, text: 'October'},
       { value: 11, text: 'November'},
       { value: 12, text: 'December'},
     ],
     month_selected: new Date().getMonth()+1,
     year_selected: new Date().getYear()+1900,
     randomizing: false,
     committing: false,
     purging: false,
     fields: [
       { key: 'order', label: 'Order'},
       { key: 'compound', label: 'Compound', class: 'text-right' },
       { key: 'enrollment_status', label: 'Status', class: 'text-center'}
     ],
     modal_fields: [
       { key: 'order', label: 'Order'},
       { key: 'actual_compound_id', label: 'Compound', class: 'text-right' }
     ],
     next_fields: [
        { key: 'order' },
        { key: 'actual_compound_id', label: 'Compound', class: 'text-right' }
      ],

      coreTarget: 10,
      bufferTarget: 15,
      totalCore: 0,
      totalBuffer: 0,
      clustersReachedCoreTarget: 0,
      clustersReachedBufferTarget: 0,
      light_trap_clusters: [
          '03',
          '10',
          '12',
          '13',
          '15',
          '16',
          '18',
          '19',
          '20',
          '25',
          '28',
          '30',
          '31',
          '37',
          '39',
          '42',
          '43',
          '48',
          '55',
          '57',
          '59'
      ],
      clusterEnrollment: {
        chartdata: {
          datasets: [
            {
              label: "Core",
              backgroundColor: "red",
              data: [45, 23]
            },
            {
              label: "Buffer",
              backgroundColor: "green",
              data: [42, 20]
            }
          ],
          labels: [1, 2]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18
            }
          },
          title: {
            display: true,
            text: "Light Trap Enrollment Progress"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster"
                }
              }
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment Count"
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        },
        myStyles: {
          height: "25vh",
          width: "100vh",
          position: "relative"
        }
      }
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/lighttraps/get_cluster_list").then(response => {
      _.each(response.data, function(item){
        that.clusters.push(item);
      });
      that.selected_cluster = response.data[0];
      that.can_randomize();
      that.get_lighttraps_by_cluster();
    });
  },
  watch: {
    selected_cluster: function(){
      let that = this;
      that.can_randomize();
      that.core = [];
      that.buffer = [];
      that.core_removed = 0;
      that.core_enrolled = [];
      that.core_pending = 0;
      that.buffer_removed = 0;
      that.buffer_enrolled = [];
      that.buffer_pending = 0;
      that.buffer_next_month = [];
      that.core_next_month = [];
      that.get_this_month_core();
      that.get_this_month_buffer();
      that.get_next_month_core();
      that.get_next_month_buffer();
      if (that.STUDY == 'kenya') {
        that.build_segment_drop_down_options();
      }
    }
  },
  methods: {
    schedule_lighttraps: function(){
      let that = this;
      let alert_string = "Are you sure you want to randomize compounds in Cluster "+that.selected_cluster+
                         " for Light Trap Enrollment in "+that.month_selected+"/"+that.year_selected+
                         "?  This will NOT make updates to CommCare or tablets."
      let api_endpoint = "/kenya/lighttraps/randomize?month="+that.month_selected+"&year="+that.year_selected+
                         "&cluster="+that.selected_cluster;

      if (that.STUDY == 'kenya') {
        api_endpoint += "&segment_number="+that.selected_segment;
        alert_string = "Are you sure you want to randomize compounds in Cluster "+that.selected_cluster+
                       ", Core: All, Buffer: Segment: "+that.selected_segment+" for Light Trap Enrollment in "+
                       that.month_selected+"/"+that.year_selected+
                       "?  This will NOT make updates to CommCare or tablets."
      }

      if(!confirm(alert_string)){
        return;
      }
      that.randomizing = true;

      HTTP.get(api_endpoint).then(() => {
        that.randomizing = false;
        that.light_traps = [];
        that.get_this_month_core();
        that.get_this_month_buffer();
        that.get_next_month_core();
        that.get_next_month_buffer();
      })
    },

    purge_lighttraps: function(){
      let that = this;
      if(!confirm("Are you sure you want to purge compounds in Cluster "+that.selected_cluster+" from Light Trap Enrollment in "+that.month_selected+"/"+that.year_selected+"?  This will remove all light traps in this cluster, making them available for use elsewhere.")){
        return;
      }
      that.purging = true;
      HTTP.get("/kenya/lighttraps/purge?month="+that.month_selected+"&year="+that.year_selected+"&cluster="+that.selected_cluster).then(() => {
        alert("These compounds have been queued up for removal of Light Trap status.  These updates will be pushed to CommCare at the top of the hour.");
        that.purging = false;
        that.light_traps = [];
        that.get_this_month_core();
        that.get_this_month_buffer();
        that.get_next_month_core();
        that.get_next_month_buffer();
      })
    },

    build_segment_drop_down_options(){
      let that = this;
      that.segment_drop_down_options = [];
      that.selected_segment = null;
      that.last_month_randomized_segment = null;

      HTTP.get("/kenya/lighttraps/get_last_month_cluster_segment?cluster="+that.selected_cluster+"&month="+that.month_selected+"&year="+that.year_selected).then(response => {
        let last_month_seg_num = response.data;
        HTTP.get("/kenya/lighttraps/get_segment_list?cluster="+that.selected_cluster).then(response => {
          let seg_nums = response.data;
          // Some clusters have only one segmet so they'll always need segment 1 enabled and selected:
          if (seg_nums.length == 1){
            that.segment_drop_down_options = seg_nums;
            that.selected_segment = 1;
          } else {
            let seg_selected = false;  // just used to keep track of whether we set that.selected_segment yet
            that.last_month_randomized_segment = last_month_seg_num;
            _.each(seg_nums, function(item){
              if(item == last_month_seg_num){
                that.segment_drop_down_options.push({ value: item, text: item+" (randomized last month)", disabled: true});
              } else {
                if(!seg_selected){  // we want to select the first enabled segment by default.
                  that.selected_segment = item;
                  seg_selected = true;
                }
                that.segment_drop_down_options.push({ value: item, text: item});
              }
            });
            console.log("OPTIONS:");
            _.each(that.segment_drop_down_options, function(item){
              console.log(item);
            });
          }
        });
      });
    },

    get_lighttraps_by_cluster: function(){
      let that = this;
      HTTP.get("/kenya/lighttraps/get_enrollment_progress").then(response => {
        let datasets = [
            {
              label: "Core",
              backgroundColor: "#37B1CA",
              data: []
            },
            {
              label: "Buffer",
              backgroundColor: "#a3d2e0",
              data: []
            },
            {
              type: "line",
              backgroundColor: "red",
              borderColor: "red",
              fill: false,
              pointRadius: 0,
              borderWidth: 1,
              label: "Core Target",
              data: []
            },
            {
              type: "line",
              backgroundColor: "orange",
              borderColor: "orange",
              fill: false,
              pointRadius: 0,
              borderWidth: 1,
              label: "Buffer Target",
              data: []
            }
          ];

          let labels = [];
          let core = {};
          let buffer = {};

          _.each(response.data, function(item) {
              core[item.cluster] = item.core;
              buffer[item.cluster] = item.buffer;
            });

            // console.log(core);
            // console.log(buffer);

            for (let x_i = 0; x_i < that.light_trap_clusters.length; x_i++) {
              let x = parseInt(that.light_trap_clusters[x_i]);
              let idx_str = String(x);

              // populate the core series
              if (idx_str in core) {
                datasets[0].data.push(core[idx_str]);
                that.totalCore += core[idx_str];

                if(core[idx_str].current_enrollment_count >= that.coreTarget) {
                  that.clustersReachedCoreTarget += 1;
                }
              } else {
                datasets[0].data.push(0);
              }

              // populate the buffer series
              if (idx_str in buffer) {
                datasets[1].data.push(buffer[idx_str]);
                that.totalBuffer += buffer[idx_str];

                if(buffer[idx_str].current_enrollment_count >= that.bufferTarget) {
                  that.clustersReachedBufferTarget += 1;
                }
              } else {
                datasets[1].data.push(0);
              }

              labels.push(x);
              datasets[2].data.push(that.coreTarget);
              datasets[3].data.push(that.bufferTarget);
            }

            that.clusterEnrollment.chartdata.datasets = datasets;
            that.clusterEnrollment.chartdata.labels = labels;
            that.loaded = true;

            setTimeout(function() {
              that.$refs['lightTrapEnrollmentProgressChart'].scrollLeft = that.$refs['lightTrapEnrollmentProgressChart'].scrollWidth / 7;
            }, 500);
      });
    },
    can_randomize(){
      let that = this;
      HTTP.get("/kenya/lighttraps/can_randomize?cluster="+this.selected_cluster).then(response => {   
        that.randomize_enabled = response.data;
      })
    },
    update_schedules(){
      let month_name = '';
      let that = this;
      _.each(that.months, function(obj){
        if(obj.value == that.month_selected){
          month_name = obj.text;
        }
      });
      this.current_month_name = month_name.toUpperCase();
      this.light_traps = [];
      this.get_month_schedules(null, 'core');
      this.get_month_schedules(null, 'buffer');
    },
    get_month_schedules(page_number, core_or_buffer){
      let that = this;
      if(core_or_buffer == 'core'){
        that.core_loading = true;
      }
      if(core_or_buffer == 'buffer'){
        that.buffer_loading = true;
      }
      if(page_number == null){
        page_number = 1;
      }
      that.this_core_page = page_number;
      HTTP.get("/kenya/lighttraps/get_month?core_or_buffer="+core_or_buffer+"&page_number="+page_number+"&cluster="+that.selected_cluster+"&month="+that.month_selected+"&year="+that.year_selected).then(response => {
        for(var i = 0; i < response.data.length; i++){
          that.light_traps.push(response.data[i]);
        }
        that.get_lighttraps();
        if(core_or_buffer == 'core'){
          that.core_loading = false;
        }
        if(core_or_buffer == 'buffer'){
          that.buffer_loading = false;
        }
      })
    },
    get_this_month_core(page_number){
      let that = this;
      that.core_loading = true;
      that.core = [];
      if(page_number == null){
        page_number = 1;
      }
      that.this_core_page = page_number;
      HTTP.get("/kenya/lighttraps/get_this_month?core_or_buffer=core&page_number="+page_number+"&cluster="+that.selected_cluster).then(response => {
        that.light_traps = [];
        for(var i = 0; i < response.data.length; i++){
          that.light_traps.push(response.data[i]);
        }
        that.get_lighttraps();
        that.core_loading = false;
      })
    },
    get_this_month_buffer(page_number){
      let that = this;
      that.buffer_loading = true;
      that.buffer = [];
      if(page_number == null){
        page_number = 1;
      }
      that.this_buffer_page = page_number;
      HTTP.get("/kenya/lighttraps/get_this_month?core_or_buffer=buffer&page_number="+page_number+"&cluster="+that.selected_cluster).then(response => {
        for(var i = 0; i < response.data.length; i++){
          // var cluster_id = parseInt(response.data[i].cluster);
          // var next_option = {
          //     value: parseInt(cluster_id),
          //     text: cluster_id
          // }

          that.light_traps.push(response.data[i]);
        }
        that.get_lighttraps();
        that.buffer_loading = false;
        return;
        
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    get_next_month_core(page_number){
      let that = this;
      if(page_number == null){
        page_number = 1;
      }
      that.next_core_page = page_number;
      HTTP.get("/kenya/lighttraps/get_next_month?core_or_buffer=core&page_number="+page_number+"&cluster="+that.selected_cluster).then(response => {
        for(var i = 0; i < response.data.length; i++){
          that.light_traps_next_month.push(response.data[i]);
          if(response.data[i].committed_to_commcare == false){
            that.next_month_scheduled = false;
          }
        }

        that.get_lighttraps();
      });
    },
    get_next_month_buffer(page_number){
      let that = this;
      if(page_number == null){
        page_number = 1;
      }
      that.next_buffer_page = page_number;
      HTTP.get("/kenya/lighttraps/get_next_month?core_or_buffer=buffer&page_number="+page_number+"&cluster="+that.selected_cluster).then(response => {
        for(var i = 0; i < response.data.length; i++){
          that.light_traps_next_month.push(response.data[i]);
          if(response.data[i].committed_to_commcare == false){
            that.next_month_scheduled = false;
          }
        }

        that.get_lighttraps();
      });
    },
    commit_light_trap_schedule: function(){
      
      let that = this;
      if(!confirm("This will commit light trap schedules for Cluster "+that.selected_cluster+" in "+that.month_selected+"/"+that.year_selected+" up to CommCare at the next half hour.  Are you sure you want to continue?")){
        return
      }
      that.committing = true;
      HTTP.get("/kenya/lighttraps/commit-lighttraps?month="+that.month_selected+"&year="+that.year_selected+"&cluster="+that.selected_cluster).then(() => {
        that.committing = false;
        alert("Light traps for Cluster "+that.selected_cluster+" in "+that.month_selected+"/"+that.year_selected+" will update in CommCare at the next half hour.");
      })
    },
    get_lighttraps: function(){
      let that = this;
      that.core = [];
      that.buffer = [];
      that.core_removed = 0;
      that.core_enrolled = [];
      that.core_pending = 0;
      that.buffer_removed = 0;
      that.buffer_enrolled = [];
      that.buffer_pending = 0;
      that.buffer_next_month = [];
      that.core_next_month = [];
      var i = 0;
      // console.log(that.light_traps);
      
      // This month:
      for(i = 0; i < that.light_traps.length; i++){
          if(that.light_traps[i].core_or_buffer == 'core'){
            that.core.push(that.light_traps[i]);

            // if(that.light_traps[i].enrollment_status == 'pending'){
            //   that.core_pending += 1;
            // }
            if(that.light_traps[i].enrollment_status == 'omitted'){
              that.core_removed += 1;
            }
            if(that.light_traps[i].enrollment_status == 'collected' || that.light_traps[i].enrollment_status == 'light trap placed'){
              that.core_enrolled.push(that.light_traps[i]);
            }
          }
          if(that.light_traps[i].core_or_buffer == 'buffer'){
            that.buffer.push(that.light_traps[i]);

            // if(that.light_traps[i].enrollment_status == 'pending'){
            //   that.buffer_pending += 1;
            // }
            if(that.light_traps[i].enrollment_status == 'omitted'){
              that.buffer_removed += 1;
            }
            if(that.light_traps[i].enrollment_status == 'collected' || that.light_traps[i].enrollment_status == 'light trap placed'){
              that.buffer_enrolled.push(that.light_traps[i]);
            }
          }
        }

      that.core_pending = (10 - that.core_enrolled.length);
      that.buffer_pending = (15 - that.buffer_enrolled.length);

      // Next month:
      for(i = 0; i < that.light_traps_next_month.length; i++){
        if(that.light_traps_next_month[i].cluster == that.selected_cluster){
          if(that.light_traps_next_month[i].core_or_buffer == 'core'){
            that.core_next_month.push(that.light_traps_next_month[i]);
          }

          if(that.light_traps_next_month[i].core_or_buffer == 'buffer'){
            that.buffer_next_month.push(that.light_traps_next_month[i]);
          }
        }
      }

    }
  }
};
</script>

<style>
</style>